<div class="task__header">
  <div class="task__header-centered">
    <h1 aria-labelledby="Header Instructions" aria-level="1" class="task__header-label navy-text">
      {{ taskTypeAction?.name }}
    </h1>
    <h2 aria-labelledby="Sub-Header Instructions" aria-level="2" class="task__header-sub-label">
      {{ taskTypeAction?.description }}
    </h2>
  </div>
</div>
<div class="task__information">
  <div class="task__information-item">
    <span aria-labelledby="Task Name for Document" class="task__information-value task__information-label--task">
      {{ task?.name }}
    </span>
  </div>
  @if (task?.programPartnerTypeId === 3 && task?.assignedStudentName) {
    <div>
      <span aria-labelledby="Student Name Field" class="task__information-label"> Student: </span>
      <span aria-labelledby="Student Name for Task" class="task__information-value">
        {{ task?.assignedStudentName }}
      </span>
    </div>
  }
  <div>
    <span aria-labelledby="Task Description Field" class="task__information-label"> Description: </span>
    <span aria-labelledby="Task Description for Document" class="task__information-value">
      {{ task?.description }}
    </span>
  </div>
  <div>
    <span aria-labelledby="Task Due Date Field" class="task__information-label"> Due Date: </span>
    <span aria-labelledby="Task Due Date" class="task__information-value">
      {{ task?.dueDate | date: 'MMM d, y' }}
    </span>
  </div>
  <div>
    <span aria-labelledby="Task Status Field" class="task__information-label"> Status: </span>
    <span aria-labelledby="Task Status" class="task__information-value">
      {{ task?.taskStatus }}
    </span>
  </div>
  <div>
    <span aria-labelledby="Most Recent Comments Field" class="task__information-label"> Most Recent Comments: </span>
    <span aria-labelledby="Most Recent Comments for Task" class="task__information-value">
      {{ recentTaskNote }}
    </span>
  </div>
  <ng-content></ng-content>
</div>
